import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'
import routes from './config/routes';
import Header from './elements/components/Header/Header';
import Footer from './elements/components/Footer/Footer';
import { ThemeProvider } from './config/themeContext';
import 'keen-slider/keen-slider.min.css';
import SideTiles from './elements/components/SideTiles/SideTiles';
import { ToastContainer } from 'react-toastify';
function App() {
  return (
    <div className="app-container">
      <ToastContainer />
      <ThemeProvider>
        <BrowserRouter>
          <Header />
          <div style={{ marginTop: "60px" }}></div>
          <SideTiles />
          <div className='content' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
            <div style={{ maxWidth: '1440px', width: '100%' }}>
              <Routes>
                {routes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}

              </Routes>
            </div>
          </div>

          <Footer />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
